import { jsx as _jsx } from "react/jsx-runtime";
import { Card } from "@mui/material";
import { forwardRef } from "react";
export const UiCardUncustomized = forwardRef((props, ref) => _jsx(Card, Object.assign({ ref: ref }, props)));
//# sourceMappingURL=ui_card_uncustomized.js.map